import {
  ContactPhone,
  Email,
  GitHub,
  // Instagram,
  LinkedIn,
  // Twitter,
} from "@material-ui/icons";
import React from "react";
import CBrace from "../FakeTags/Brace/CBrace";
import OBrace from "../FakeTags/Brace/OBrace";
import styles from "./ContactMe.module.css";
import BusinessIcon from "@material-ui/icons/Business";

function ContactMe() {
  return (
    <div className={styles.container} id="contactMe">
      <div className={styles.left}>
        <h1 className={styles.head}>Contact Me</h1>
        <OBrace />
        <div className={styles.details}>
          <div className={styles.up}>
            <p className={styles.description}>
              Interested in working together? Fill out the form below with some
              info about your project and I will get back to you as soon as I
              can. Please allow a couple days for me to respond.
            </p>
            <p className={styles.info}>
              <BusinessIcon />
              <span>
                Chitkara University, Chandigarh NH 7, 64, Tehsil, Rajpura,
                Punjab 14040
              </span>
            </p>
            <a
              href="mailto:raghav0022.cse19@chitkara.edu.in"
              className={styles.info}
            >
              <Email /> <span>raghav0022.cse19@chitkara.edu.in</span>
            </a>
            <a href="tel:9950210990" className={styles.info}>
              <ContactPhone /> <span>99502-10990</span>
            </a>
          </div>
          <div className={styles.down}>
            <h3 className={styles.connect}>Connect with me:</h3>
            <ul className={styles.socialMedia}>
              {/* <li>
                <a href="http://localhost:3000/#home">
                  <Instagram style={{ fontSize: "40px" }} />
                </a>
              </li> */}
              <li>
                <a
                  href="https://www.linkedin.com/in/raghav-aggarwal-65559b195/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  <LinkedIn style={{ fontSize: "40px" }} />
                </a>
              </li>
              <li>
                <a
                  href="https://github.com/raghavaggarwal2308"
                  target="_blank"
                  rel="noreferrer"
                >
                  <GitHub style={{ fontSize: "40px" }} />
                </a>
              </li>
              {/* <li>
                <a href="https://github.com/raghavaggarwal2308">
                  <Twitter style={{ fontSize: "40px" }} />
                </a>
              </li> */}
            </ul>
          </div>
        </div>

        <CBrace />
      </div>
      <div className={styles.right}>
        <h1 className={styles.workTogether}>
          Interested to work together?
          <br />
          Let's talk
        </h1>
        <OBrace />
        <form
          action="https://formsubmit.co/raghav0022.cse19@chitkara.edu.in"
          method="POST"
        >
          <div className={styles.sender}>
            <input type="text" placeholder="Your Name" name="name" required />
            <input type="email" placeholder="Email" name="email" required />
          </div>
          <textarea
            rows="8"
            cols="50"
            placeholder="Message ..."
            name="message"
            required
          ></textarea>
          <br />
          <input
            type="hidden"
            name="_next"
            value="https://raghavaggarwal.netlify.app/"
          />
          <input type="hidden" name="_subject" value="New submission!" />
          <input type="hidden" name="_captcha" value="false" />
          <input type="hidden" name="_template" value="basic" />
          <input
            type="hidden"
            name="_autoresponse"
            value="Thank You! for connecting with me I will connect back to you soon!"
          />
          <button type="submit">Okay! Submit</button>
        </form>
        <CBrace />
      </div>
    </div>
  );
}

export default ContactMe;
